import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import axios from 'axios';

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";

import { Button, Heading, Modal, ModalContent, ModalHeader, ModalFooterButtons} from "monday-ui-react-core";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

import Monday from "../auth/useMonday.jsx";
import Loader from "../libs/loader.jsx";

import historyHelper from "./helper.jsx";

class Changes extends React.Component
{
    constructor(props)
    {
        super(props);
        //console.log("DatasetShare constructor",this.props);
        this.params = this.props.router.params;
        
        this.user = this.props.auth.user;
        
        this.action = [];
        if( (`action` in this.props) && this.props.action!=null )
        {
            this.action = this.props.action;
        }
        
        this.data = null;
        if( (`data` in this.props) && this.props.data!=null )
        {
            this.data = this.props.data;
        }
        
        this.state = {
            'show': false,
            
            'user': this.user,
        };
        
        this.openModalButtonRef = this.props.openModalButtonRef;
        
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        
        this.synStateTimer = false;
    }
    
    async promisedSetState(newState)
    { 
        var state = this.state;
        for(let key of Object.keys(newState))
        {
            state[key] = newState[key];
        }
        
        this.state = state;
        
        var this_component = this;
        if(this.synStateTimer==false)
        {
            this.synStateTimer = setTimeout( () => { 
                this_component.setState( {...this_component.state} );
                this_component.synStateTimer = false; 
            }, 100);
        }
        
        return true;
    }
    
    async showModal()
    {
        var this_component = this;
        
        if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.showLoader();
        
        await this_component.promisedSetState({'show': true});
        
        if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.hideLoader();
    }

    async closeModal()
    {
        var this_component = this;
        
        await this_component.promisedSetState({'show': false});
    }
    
    
    render()
    {
        var this_component = this;
        
        var title = config.texts.changes.actions.changed;
        
        if(this_component.action.includes("created"))
        {
            title = config.texts.changes.actions.created;
        }
        
        if(this_component.action.includes("deleted"))
        {
            title = config.texts.changes.actions.deleted;
        }
        
        return (
            <div style={this_component.props.style}>
                <Modal triggerElement={this_component.openModalButtonRef.current?this_component.openModalButtonRef.current:null} show={this_component.state.show} onClose={this_component.closeModal} width={Modal.width.FULL_WIDTH} contentSpacing>
                    <ModalHeader style={{'fontWeight':'bold'}}><Heading type={Heading.types.h4} style={{'fontWeight':'bold'}} value={title} className="pl-0 mt-0" customColor="var(--primary-text-color)" /></ModalHeader>
                    <ModalContent>
                        <Loader ref={this_component.loader}>
                            <div className="container-fluid" style={{'color':'var(--primary-text-color)'}}>
                                <div className="row">
                                    <div className="col-12">
                                        
                                        {historyHelper.formatChanges(this_component.action, this_component.data)}
                                        
                                        {/*
                                        <p>
                                            {JSON.stringify( this_component.data )}
                                        </p>
                                        */}
                                        
                                    </div>
                                </div>
                            </div>
                        </Loader>
                    </ModalContent>
                    <ModalFooterButtons primaryButtonText="Close" onPrimaryButtonClick={this_component.closeModal} />
                </Modal>
            </div>
        );
    }
}

Changes.propTypes = {
    'action': PropTypes.any,
    'data': PropTypes.any,
    'style': PropTypes.object
};

Changes.defaultProps = {
    style: {'display': 'none'}
};

export default withRouter(withAuth(Changes));
